import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-t border-amber-200 bg-amber-50 p-3.5 text-xs font-medium text-amber-800",
  role: "status"
}
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.visible)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _createTextVNode(_toDisplayString($setup.t('whatsappMeta.quota.fullNotice', { limit: $props.limit })) + " ", 1 /* TEXT */),
        _createElementVNode("a", {
          class: "text-primary underline",
          href: `mailto:${$setup.supportEmail}`
        }, _toDisplayString($setup.supportEmail), 9 /* TEXT, PROPS */, _hoisted_2),
        _cache[0] || (_cache[0] = _createTextVNode(". ", -1 /* CACHED */))
      ]))
    : _createCommentVNode("v-if", true)
}